<template>
  <div class="folder-page">
    <div class="collect-header">
      <a href="javascript:;" class="dirName-title" @click="handleBack">
        <div class="back-bg">
          <i class="el-icon-back"></i>
        </div>
        {{ dirName }}
      </a>
    </div>
    <div v-if="totalCount > 0" class="survey-container">
      <el-row class="mine-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            class="th-column"
            prop="title"
            label="问卷"
            show-overflow-tooltip
            width="500"
          >
            <template slot-scope="scope">
              <a
                href="javascript:;"
                v-if="!scope.row.editRemark"
                @click="handleEdit(scope.row)"
                class="wj-name"
              >
                <svg class="icon svg-icon wj-survey-icon" aria-hidden="true">
                  <use xlink:href="#icon-icon_wenjuan" />
                </svg>
                {{ removeLables(scope.row.remarkName || scope.row.title) }}（{{
                  scope.row.id
                }}）
              </a>
              <el-input
                v-else
                class="remarkInput"
                :id="'remarkInput' + scope.row.id"
                @blur="handleBlur(scope.row)"
                v-model="scope.row.remarkName"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="status" align="center" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">
                <i class="collect-icon"></i>正在发放
              </span>
              <span v-if="scope.row.status === 2">
                <i class="pause-icon"></i>暂停发放
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="recycleCount"
            align="center"
            label="回收量"
            min-width="200"
          >
            <template slot-scope="scope">
              <a
                href="javascript:;"
                class="operate-a recycle-count"
                @click="handleAnalysis(scope.row)"
                >{{ scope.row.recycleCount }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            min-width="200"
          ></el-table-column>

          <el-table-column min-width="400" align="left" label="操作">
            <template slot-scope="scope">
              <a
                href="javascript:;"
                class="operate-a"
                @click="handleRename(scope.row)"
                >重命名</a
              >
              <!-- 隐去复制按钮 -->
              <!-- <a
                href="javascript:;"
                class="operate-a"
                @click="handleCopy(scope.row)"
                >复制</a
              > -->
              <a
                href="javascript:;"
                class="operate-a"
                @click="handleDelete(scope.row)"
                >删除</a
              >
              <a
                href="javascript:;"
                class="operate-a"
                @click="handleSurveyRemove(scope.row)"
                >移出文件夹</a
              >
              <el-cascader
                expand-trigger="hover"
                :options="dropOptions"
                v-model="dropDownVal"
                @focus="handleDropFocus(scope.row)"
                @change="dropDownChange(scope.row, scope.$index)"
              ></el-cascader>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="mb40">
        <div class="pager-center">
          <el-pagination
            @current-change="getList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="totalItem"
          ></el-pagination>
        </div>
      </el-row>
    </div>
    <div v-else-if="totalCount === -1" class="survey-container"></div>
    <div v-else class="empty-page survey-container">
      <img src="../assets/empty.png" alt />
      <span style="color: #999">您还没有问卷</span>
    </div>
    <share-dialog :dialogShow.sync="shareDialogShow"></share-dialog>
    <export-dialog
      :surveyId="surveyId"
      :dialogShow.sync="txtDialogShow"
    ></export-dialog>
  </div>
</template>

<script>
import http from "../utils/http";
import { htmlToTxtMixin } from "../utils/mixins.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { timeToLocal, exportFile, MSG } from "../utils/utils";
import shareDialogNew from "../components/shareDialogNew.vue";
import exportDialog from "../components/exportDialog.vue";
let dropOptionsType1 = [
  {
    label: "开始发放",
    value: "startRecycle",
  },
  {
    label: "分享问卷链接",
    value: "share",
  },
  {
    label: "问卷预览",
    value: "preview",
  },
  {
    label: "数据统计",
    value: "sjtj",
    children: [
      {
        value: "analysis",
        label: "在线统计",
      },
      {
        value: "outExcel",
        label: "导出EXCEL",
      },
      {
        value: "outSpss",
        label: "导出SPSS",
      },
      {
        value: "clear",
        label: "清空数据",
      },
    ],
  },
  {
    label: "问卷编辑",
    value: "edit",
  },
  {
    value: "output",
    label: "导出问卷TXT",
  },
  {
    value: "print",
    label: "打印问卷",
  },
];

let dropOptionsType2 = [
  {
    label: "开始发放",
    value: "startRecycle",
    disabled: true,
  },
  {
    label: "分享问卷链接",
    value: "share",
    disabled: true,
  },
  {
    label: "问卷预览",
    value: "preview",
    disabled: true,
  },
  {
    label: "数据统计",
    value: "sjtj",
    children: [
      {
        value: "analysis",
        label: "在线统计",
      },
      {
        value: "outExcel",
        label: "导出EXCEL",
        disabled: true,
      },
      {
        value: "outSpss",
        label: "导出SPSS",
        disabled: true,
      },
      {
        value: "clear",
        label: "清空数据",
        disabled: true,
      },
    ],
  },
  {
    label: "问卷编辑",
    value: "edit",
    disabled: true,
  },
  {
    value: "output",
    label: "导出问卷TXT",
    disabled: true,
  },
  {
    value: "print",
    label: "打印问卷",
    disabled: true,
  },
];
let _id = 0;
export default {
  name: "Mine",
  mixins: [htmlToTxtMixin],
  data() {
    return {
      interface: {
        getSurvey: `/survey/get`,
        getList: `/survey/list`,
        copySurvey: `/survey/copySurvey`,
        deleteSurvey: `/survey/del`,
        rename: `/survey/remarkNameEdit`,
        startRecycle: `/survey/startRecycle`,
        pauseRecycle: `/survey/suspendRecycle`,
        qrcode: `/survey/qrcode`,
        outExcel: `/stat/exportData`,
        exportTemplateIn: `/survey/exportTemplateIn`,
        exportTemplateOut: `/survey/exportTemplateOut`,
        clearData: `/stat/clear`,
        editStat: `/survey/editStat`,
        surveyTitle: `/search/surveyTitle`,
        surveyList: `/search/survey`,
        surveyOutDir: `/survey/op/outDir`,
        listSurveyByDir: `/survey/op/listSurveyByDir`,
        addDir: `//surveyDir/addDir`,
        renameDir: `/surveyDir/rename`,
        deleteDir: `/surveyDir/deleteDir`,
        listDir: `/surveyDir/listDir`,
      },
      shareSurvey: null,
      tableData: [],
      pageSize: 15,
      currentPage: 1,
      totalItem: 15,
      totalCount: -1,
      shareDialogShow: false,
      txtDialogShow: false,
      shareAddr: "",
      isCollecting: false,
      qrcodeUrl: "",
      qrcodeSmall: "",
      qrcodeMid: "",
      qrcodeBig: "",
      qrcodeSL: "",
      excelUrl: "",
      spssUrl: "",
      htmlToTxt: "",
      surveyId: "",
      dropOptions: this.deepClone(dropOptionsType1),
      dropDownVal: [],
      canEdit: true,
      disableAction: [
        "startRecycle",
        "stopRecycle",
        "share",
        "outSpss",
        "clear",
        "edit",
        "copy",
        "delete",
        "rename",
        "output",
        "print",
      ],
      titleList: [],
      selectedTitle: "",
      loading: false,
      searchTableData: [],
      isEnter: false,
      isCreateNewDir: false,
      copyTitle: "",
      userName: "",
    };
  },
  mounted() {
    let data = localStorage.getItem("survey-user");
    let { userName } = JSON.parse(data);
    this.userName = userName;
    localStorage.removeItem("expr");
    localStorage.removeItem("filterArr");
    localStorage.removeItem("filterStr");
    this.getList();
    this.saveSurveyRole(0);
  },
  computed: {
    dirId() {
      return this.$route.query.id;
    },
    dirName() {
      return this.$route.query.name;
    },
  },
  methods: {
    ...mapMutations(["setShareSurvey"]),
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleSelectChange(val) {
      this.selectRow = val;
    },
    handleSearch() {},
    handleCreateSurvey() {
      this.$router.push({
        path: "/home/edit",
      });
    },
    getList() {
      http
        .get(this.interface.listSurveyByDir, {
          page: this.currentPage,
          pageSize: this.pageSize,
          dirId: this.dirId,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.totalCount = data.totalCount;
            if (this.totalCount == 0) {
              this.tableData = [];
              return;
            }
            data.recordList.forEach((val) => {
              val.createTime = timeToLocal(new Date(+val.createTime)).date;
              val.editRemark = false;
            });
            this.tableData = data.recordList;
            this.totalItem = data.totalPage * this.pageSize;
            this._updateSubSurveyBg();
          } else {
            MSG.error(message);
          }
          this.$nextTick(() => {
            document.querySelector(
              ".folder-page .mine-list .el-table tr > th"
            ).style.paddingLeft = "48px";
          });
        });
    },
    handleShare(row) {
      this.shareSurvey = row;
      let { id, url, hash, status } = row;
      this.setShareSurvey({ id, url, status, hash });
      this.shareDialogShow = true;
    },
    handleExpand(row) {
      this.excelUrl = `${this.interface.outExcel}?surveyId=${row.id}&type=excel`;
    },
    handleStart(row, idx) {
      http
        .post(this.interface.startRecycle, {
          surveyId: row.id,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            row.status = 1;
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handlePause(row, idx) {
      http
        .post(this.interface.pauseRecycle, {
          surveyId: row.id,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            row.status = 2;
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handleEdit(row) {
      this.saveSurveyRole(row.role);
      if (row.role == 2 || row.status !== 2) {
        this.$router.push({
          path: "/home/edit/analysis",
          query: {
            id: row.id,
            tab: "analysis",
          },
        });
      } else {
        this.$router.push({
          path: "/home/edit",
          query: {
            id: row.id,
            openCooperation: row.openCooperation,
          },
        });
      }
    },
    handleOutputTxt({ id, title }) {
      this.txtDialogShow = true;
      this.surveyId = id;
    },
    handleCopy(row) {
      http
        .post(this.interface.copySurvey, {
          surveyId: row.id,
          dirId: this.dirId,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            MSG.success("问卷复制成功,复制问卷设置清空");
            this.copyTitle = (row.remarkName || row.title) + "_副本";
            this.getList();
          } else {
            MSG.error(message);
          }
        })
        .catch(() => {});
    },
    handleDelete(row) {
      this.$confirm("问卷删除后将无法恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this._deleteSurvey(row);
        })
        .catch(() => {});
    },
    _deleteSurvey(row) {
      http
        .post(this.interface.deleteSurvey, {
          surveyId: row.id,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success("删除成功");
          } else {
            MSG.error(message);
          }
        })
        .catch((error) => {
          MSG.error(message);
        });
    },
    handleRename(row) {
      row.remarkName =
        this.removeLables(row.remarkName) || this.removeLables(row.title);
      row.editRemark = true;
      this.$nextTick(() => {
        document.getElementById("remarkInput" + row.id).focus();
      });
    },
    handleBlur(row) {
      row.editRemark = false;
      if (!row.remarkName) {
        MSG.warning("重命名不能为空");
        return;
      }
      this._renameSurvey(row);
    },
    _renameSurvey(row) {
      http
        .post(this.interface.rename, {
          surveyId: row.id,
          remarkName: row.remarkName,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            MSG.success("保存成功");
          } else {
            MSG.error(message);
          }
        });
    },
    handleCreate() {
      this.$router.push({
        path: "/home/edit",
        query: {},
      });
    },
    handleOpenUrl() {
      window.open(this.shareAddr);
    },
    handleCopyUrl() {
      const range = document.createRange();
      range.selectNode(document.getElementById("shareInput"));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      MSG.success("已复制");
    },
    handleOutExcel(row) {
      this.excelUrl = `${this.interface.outExcel}?surveyId=${row.id}&type=excel`;
      if (row.recycleCount === 0) {
        MSG.warning("该问卷暂无发放数据");
      } else {
        window.open(this.excelUrl);
      }
    },
    handlePreview(row) {
      this.$router.push({
        path: "preview",
        query: {
          url: row.url,
        },
      });
    },
    handleAnalysis(row) {
      this.$router.push({
        path: "/home/edit/analysis",
        query: {
          id: row.id,
          tab: "analysis",
          role: row.role,
        },
      });
    },
    handleOutSpss(row) {
      this.spssUrl = `${this.interface.outExcel}?surveyId=${row.id}&type=spss`;
      if (row.recycleCount === 0) {
        MSG.warning("该问卷暂无发放数据");
      } else {
        window.open(this.spssUrl);
      }
    },
    handlePrint(row) {
      window.open(`/#/print?id=${row.id}`);
    },
    handleClear(row) {
      this.$confirm("数据清空后将无法恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        http
          .get(this.interface.clearData, {
            surveyId: row.id,
          })
          .then((response) => {
            const { code, data, message } = response;
            if (code === 1) {
              MSG.success("清除成功");
            } else {
              MSG.error(message);
            }
          })
          .catch((error) => {
            MSG.error(error);
          });
      });
    },
    dropDownChange(row, index) {
      let action = this.dropDownVal.pop();
      switch (action) {
        case "startRecycle":
          sethislf.handleStart(row);
          break;
        case "stopRecycle":
          this.handlePause(row);
          break;
        case "share":
          this.handleShare(row);
          break;
        case "preview":
          this.handlePreview(row);
          break;
        case "analysis":
          this.handleAnalysis(row);
          break;
        case "outSpss":
          this.handleOutSpss(row);
          break;
        case "outExcel":
          this.handleOutExcel(row);
          break;
        case "clear":
          this.handleClear(row);
          break;
        case "edit":
          this.handleEdit(row);
          break;
        case "copy":
          this.handleCopy(row);
          break;
        case "delete":
          this.handleDelete(row, index);
          break;
        case "rename":
          this.handleRename(row);
          break;
        case "output":
          this.handleOutputTxt(row);
          break;
        case "print":
          this.handlePrint(row);
          break;
      }
    },
    handleDropFocus(row) {
      this.dropDownVal = [];
      if (row.status === 1) {
        this.dropOptions.splice(0, 1, {
          value: "stopRecycle",
          label: "暂停发放",
        });
      } else {
        this.dropOptions.splice(0, 1, {
          value: "startRecycle",
          label: "开始发放",
        });
      }
      this.saveSurveyRole(row.role);
      this.querySurveyEditStat(row);
    },
    querySurveyEditStat(row) {
      if (row.openCooperation) {
        http
          .get(this.interface.editStat, {
            surveyId: row.id,
          })
          .then((response) => {
            const { code, data, message } = response;
            if (code === 1) {
              if (data.edit || (!data.edit && data.editor == this.userName)) {
                this.canEdit = true;
              } else {
                this.canEdit = false;
              }
            }
            this.changeCascaderOptions(row);
          })
          .catch((error) => {
            MSG.error(error);
          });
      } else {
        this.canEdit = true;
        this.dropDownVal = [];
        this.dropOptions = this.deepClone(dropOptionsType1);
        this.changeRecycleStatus(row, false);
      }
    },
    changeCascaderOptions(row) {
      this.dropDownVal = [];
      if (row.openCooperation) {
        if (!this.canEdit || row.role == 2) {
          this.dropOptions = this.deepClone(dropOptionsType2);
          this.changeRecycleStatus(row, true);
        } else {
          this.dropOptions = this.deepClone(dropOptionsType1);
          this.changeRecycleStatus(row, false);
        }
      } else {
        this.dropOptions = this.deepClone(dropOptionsType1);
        this.changeRecycleStatus(row, false);
      }
    },
    changeRecycleStatus(row, enable) {
      if (row.status === 1) {
        this.dropOptions.splice(0, 1, {
          value: "stopRecycle",
          label: "暂停发放",
          disabled: enable,
        });
      } else {
        this.dropOptions.splice(0, 1, {
          value: "startRecycle",
          label: "开始发放",
          disabled: enable,
        });
      }
    },
    handleSearchSurveyTitle(query) {
      if (query !== "") {
        this.loading = true;
        http
          .get(this.interface.surveyTitle, {
            key: query,
          })
          .then((response) => {
            this.loading = false;
            const { code, data, message } = response;
            if (code === 1) {
              this.titleList = data;
            } else {
              MSG.error(message);
            }
          })
          .catch((error) => {
            this.loading = false;
            MSG.error(error);
          });
      } else {
        this.titleList = [];
      }
    },
    selectSurvey(title) {
      if (title !== "") {
        http
          .get(this.interface.surveyList, {
            key: title,
          })
          .then((response) => {
            const { code, data, message } = response;
            if (code === 1) {
              this.totalCount = data.length;
              data.forEach((val) => {
                val.createTime = timeToLocal(new Date(+val.createTime)).date;
                val.editRemark = false;
              });
              this.searchTableData = data;
              this.tableData = this.searchTableData.slice(0, 15);
              this.totalItem = data.length;
              this.currentPage = 1;
              this.pageSize = 15;
            } else {
              MSG.error(message);
            }
          })
          .catch((error) => {
            MSG.error(error);
          });
      } else {
      }
    },
    handleSelectSurvey() {
      this.selectSurvey(this.selectedTitle);
      this.isEnter = false;
    },
    handleSearchSurvey() {
      this.$refs.select.handleClose();
      let val = document.querySelector(".el-select .el-input input").value;
      this.selectedTitle = val;
      if (val) {
        this.selectSurvey(val);
        this.isEnter = true;
      } else {
        this.searchTableData = [];
        this.getList();
      }
    },
    handleSelectBlur() {
      if (this.isEnter) {
        this.selectedTitle = document.querySelector(
          ".el-select .el-input input"
        ).value;
      }
    },
    handleSurveyRemove(row) {
      http
        .get(this.interface.surveyOutDir, {
          surveyList: row.id,
          dirId: this.dirId,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handleSurveyUntop(row) {
      http
        .get(this.interface.surveyUntop, {
          surveyId: row.id,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handleAddDir() {
      _id = +new Date();
      this.tableData.unshift({
        role: 0,
        status: 0,
        title: "新建文件夹",
        type: 2,
        id: _id,
        editRemark: true,
        remarkName: "新建文件夹",
        isCreateNewDir: true,
      });
      this.$nextTick(() => {
        document.getElementById("remarkInput" + _id).focus();
      });
    },
    _addDir(row) {
      http
        .get(this.interface.addDir, {
          dirName: row.remarkName || "新建文件夹",
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    _renameDir(row) {
      http
        .get(this.interface.renameDir, {
          surveyDirId: row.id,
          dirName: row.remarkName,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    _deleteDir(row) {
      http
        .get(this.interface.deleteDir, {
          dirId: row.id,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handleListSurveyByDir(row) {
      http
        .get(this.interface.surveyUntop, {
          surveyId: row.id,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    handleListDir(row) {
      http
        .get(this.interface.surveyTop, {
          surveyId: row.id,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.getList();
            MSG.success(message);
          } else {
            MSG.error(message);
          }
        });
    },
    _updateSubSurveyBg() {
      this.$nextTick(() => {
        let trEles = this.$el.querySelector(
          ".folder-page .mine-list .el-table tbody"
        ).children;
        this.tableData.forEach((item, index) => {
          if (item.title == this.copyTitle) {
            trEles[index].style.backgroundColor = "#F5F7FA";
          }
        });
      });
    },
    handleBack() {
      this.$router.push({
        path: "mine",
      });
    },
    ...mapActions(["saveSurveyRole"]),
  },
  components: {
    shareDialogNew,
    exportDialog,
  },
};
</script>

<style lang="scss">
.folder-page {
  height: 100%;
  overflow-y: scroll;
  background-color: #fff;
  padding-bottom: 60px;
  .remarkInput {
    width: 200px;
    input {
      height: 30px;
      line-height: 14px;
      font-size: 14px;
      padding: 8px;
    }
  }
  .survey-container {
    min-height: 400px;
    margin-left: 50px;
    margin-right: 50px;
    background-color: #fff;
    position: relative;
    z-index: 10;
  }
  .empty-page {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    .collect-btn {
      margin-top: 15px;
      width: 150px;
    }
  }
  .el-button--primary {
    font-weight: normal;
  }
  .views-control {
    a {
      height: 60px;
      padding: 0 15px;
      float: left;
      color: #333;
      border-left: 1px solid #e1e6eb;
      i {
        font-size: 24px;
        color: #999;
        vertical-align: sub;
        margin-right: 8px;
      }
      &:hover,
      &.active {
        color: #ff552e;
        i {
          color: #f1b6a7;
        }
      }
    }
  }
  .mine-list {
    .el-icon-arrow-down:before {
      content: "\E646";
    }
    .el-input__suffix-inner:hover {
      color: #ff552e;
    }
  }
  .el-table {
    &.el-table--fit {
      border: 1px solid #ebeef5;
      border-bottom: none;
    }
    .cell {
      padding-left: 0;
      padding-right: 0;
    }
    th {
      font-weight: normal;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      line-height: 18px;
    }
    tbody tr {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
    }
    .pause-icon,
    .collect-icon {
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #ff552e;
      border-radius: 50%;
      margin-right: 5px;
    }
    .collect-icon {
      background-color: #479de6;
    }
    .wj-name {
      height: 34px;
      line-height: 34px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      margin-left: 50px;
      cursor: pointer;
      position: relative;
      bottom: 3px;
      &:hover {
        color: #ff552e;
      }
      .wj-survey-icon {
        position: relative;
        top: 8px;
        width: 28px;
        height: 30px;
        left: -5px;
      }
    }
    .el-button--default {
      background-color: transparent;
      border: 0;
    }
  }
  .el-table tr,
  .el-table th,
  .el-table td {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    height: 50px !important;
  }
  .el-input__suffix {
    color: #999;
  }
  .el-dialog__body {
    padding: 20px 40px 50px 40px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .mb40 {
    margin-bottom: 40px;
  }
  .pager-center {
    display: flex;
    justify-content: center;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-cascader {
    .el-input__inner {
      border: none;
      width: 20px;
      padding: 0 25px;
      background-color: transparent;
    }
    .el-cascader__label {
      display: none;
    }
  }
}
.el-dropdown-menu__item {
  padding: 0;
  a {
    display: block;
    padding: 0 20px;
  }
}
.view-search {
  position: relative;
}
.fixed-button {
  position: absolute;
}
.el-cascader-menu {
  height: auto;
}
.el-cascader-menus.el-popper {
  ul:last-child:not(:nth-child(2)) {
    position: absolute;
    top: 70px;
    height: 150px;
    border: 1px solid #eee;
  }
  ul:nth-child(2) li:nth-child(8) {
    border-bottom: 1px solid #eee;
  }
  ul:nth-child(2) li:nth-child(4) {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
}
.wj-icon {
  width: 20px;
  height: 15px;
  padding-left: 5px;
  display: inline-block;
  vertical-align: sub;
  background-image: url(../assets/sprite@3x.png);
  background-size: 525px 875px;
}
.wj-icon.user-icon {
  height: 28px;
  line-height: 28px;
  width: 30px;
}
.wj-icon.browser-icon {
  background-position: -35px -468px;
}
.wj-icon.manager-icon {
  background-position: 0 -468px;
}
.wj-icon.creater-icon {
  background-position: -140px -468px;
}
.wj-icon.creater-un-icon {
  background-position: -810px -468px;
}
.collect-header {
  height: 60px;
  line-height: 60px;
  padding-left: 10px;
  background-color: #ebebeb;
  border-bottom: 1px solid #eee;
  position: relative;
  .el-select input {
    padding: 4px 30px;
    line-height: 14px;
  }
}
.operate-a {
  display: inline-block;
  padding-right: 20px;
  &:hover {
    color: #ff552e;
  }
}
.zhiding-a {
  color: #ff552e;
  cursor: pointer;
  display: inline-block;
  width: 80px;
}
.back-bg {
  display: inline-block;
  width: 30px;
  height: 30px;
  background-color: #fff;
  border-radius: 50%;
  line-height: 30px;
  text-align: center;
  margin-right: 15px;
  margin-left: 40px;
}
.recycle-count {
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/folder.vue